const ITEMS = [
  "TIM WANYONYI 2027",
  "BUNGOMA GOVERNOR",
  "SERVICE",
  "INTEGRITY",
  "PROGRESS",
  "LINDA MWANANCHI",
  "ODM TICKET",
];

export const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    className="overflow-hidden border-y border-white/10 bg-[#12141C] py-5 select-none"
    aria-hidden="true"
  >
    <div className="marquee-track flex w-max whitespace-nowrap items-center">
      {[...ITEMS, ...ITEMS].map((t, i) => (
        <span key={i} className="flex items-center">
          <span
            className={`font-display font-bold text-xl sm:text-2xl tracking-wide px-6 ${
              i % 2 === 0 ? "text-stone-200" : "text-stone-600"
            }`}
          >
            {t}
          </span>
          <span className="text-orange-500 text-lg">•</span>
        </span>
      ))}
    </div>
  </div>
);
